import setFullbanner from './home/1_fullbanner';
import setMinibanner from './home/1_minibanner';
import setCarousel from '../components/carousel';
import setProductSlider from './home/3_product_slider';
import CategoryTabs from './home/3_category_tabs';
import setReviewsSwiper from './home/reviews';
//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner();
    setMinibanner();
		setCarousel();
		setProductSlider()
		CategoryTabs.init();
    setReviewsSwiper();
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
